// Lib
import { createAction } from 'redux-actions';

export const OpenDrawer = createAction('OPEN_DRAWER');
export const CloseDrawer = createAction('CLOSE_DRAWER');
export const RemoveDrawerState = createAction('REMOVE_DRAWER_STATE');
